export default "__VITE_ASSET__b4K8UT_l__";